import NProgress from 'nprogress/nprogress'

export default {
  data() {
    return {
      loading:false,
      errorMessage:''
    }
  },
  methods: {
    toggleLoading() {
      this.loading = !this.loading
      if(this.loading){
        NProgress.start()
      }else{
        NProgress.done()
      }
    },
    setError(msg){
      this.errorMessage = msg
    },
    validateForm() {
      this.setError('')
      this.$v.model.$touch();
      return this.$v.model.$anyError;
    }
  }
}